<template>
	<li
		class="menu_item__parent"
		@mouseover="show = true"
		@mouseleave="show = false"
		:class="{
			last: menuNumber === menuLength - 1,
			'has-children':
				this.$attrs['has-children'],
			selected: this.$attrs['selected'],
		}"
	>
		<div class="parent_container">
			<a
				class="menu_item__parent__primary_link"
				:href="localUrlSwap(menu_item['url'])"
				v-html="menu_item['title']"
				ref="test"
			></a>
			<div
				class="has-children-indicator"
				v-if="this.$attrs['has-children']"
			>
				<svg
					fill="none"
					viewBox="0 0 117 68"
				>
					<defs />
					<path
						fill="#fff"
						d="M58.5 68L0 9.70228 9.67228 0 58.5 48.6589 107.328 0 117 9.70228 58.5 68z"
					/>
				</svg>
			</div>
		</div>

		<transition name="slide-fade">
			<div
				class="inner_menu_child"
				v-if="show && menu_item['children']"
			>
				<ul
					class="menu__child"
					ref="menu_child"
					:style="{
						'--distance-from-left': this.menuPosition(),
					}"
				>
					<li
						class="menu_item__child"
						v-for="(sub_menu_item, index) in menu_item['children']"
						:key="index"
						@mouseover="selectedMenuImage = sub_menu_item['menu_icon']"
						@mouseleave="selectedMenuImage = false"
					>
						<a
							v-if="sub_menu_item"
							:href="localUrlSwap(sub_menu_item['url'])"
							v-html="sub_menu_item['title']"
						></a>
					</li>
				</ul>
			</div>
		</transition>
	</li>
</template>

<script>
export default {
	data() {
		return {
			param: undefined,
			selected: {},
			removed: {},
			sidePanelVisible: false,
			show: false,
			selectedMenuImage: false,
			topScrollThreshold: 100,
			windowInnerWidth: 0,
			isScrolled: false,
			isOffscreen: false,
			menuPos: 0,
			window: {
				width: 0,
				height: 0,
			},
		};
	},
	props: {
		menu_item: {},
		currentMenuItem: {
			type: Boolean,
			default: false,
		},
		imagePath: {},
		menuLength: {
			default: 0,
		},
		menuNumber: {
			default: 0,
		},
	},
	computed: {},
	watch: {
		selectedMenuImage() {
			if (this.selectedMenuImage) {
				this.selectedMenuImage
					.replace(/[^a-z0-9]/gi, '-')
					.replace('&#038;', '-')
					.toLowerCase();
			}
		},
		show() {
			this.isScrolled = true;
		},
	},

	methods: {
		didScroll() {
			this.isScrolled = window.scrollY > this.topScrollThreshold;
		},

		localUrlSwap(value) {
			if (window.location.host === 'localhost:3000') {
				return value.replace('cpmec.test', 'localhost:3000');
			} else {
				return value;
			}
		},

		menuPosition() {
			return (
				(this.$refs['test'] &&
					this.$refs['test'].getBoundingClientRect().left) -
				10 +
				'px'
			);
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			this.menuPosition();
		},
	},

	components: {},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('scroll', this.didScroll);
		this.handleResize();
		this.menuPosition();
	},

	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
	},

	mounted() {
		this.handleResize();
		this.menuPosition();
	},

	updated() {
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.parent_container {
	position: relative;
	z-index: 200;
	display: flex;
	column-gap: calc(var(--spacer) / 2);

	&:hover {
		cursor: pointer;

		> a {
			color: var(--cpmec-green);
			transition: color 0.2s ease;
			cursor: pointer;
		}

		.has-children-indicator {
			svg {
				path {
					fill: var(--cpmec-green);
					transition: color 0.2s ease;
				}
			}
		}
	}
}

li {
	display: flex;

	&:hover {
		cursor: pointer;
		color: var(--cpmec-green);
	}

	a {
		font-family: var(--primary-font-family);
		color: var(--white);
		display: flex;
		height: 100%;
		align-items: center;
		transition: color 0.2s ease;
		align-items: flex-start;
		text-decoration: none;

		&:hover {
			color: var(--cpmec-blue);
			transition: color 0.2s ease;
			cursor: pointer;
		}
	}

	.has-children-indicator {
		width: 18px;
		height: 18px;

		// &:hover {
		// 	svg {
		// 		path {
		// 			fill: red;
		// 		}
		// 	}
		// }

		svg {
			width: 100%;

			path {
				fill: var(--cpmec-blue);
				transition: color 0.2s ease;
			}
		}
	}

	&.menu_item__parent {
		font-family: var(--primary-font-family);
		color: var(--cpmec-blue);
		display: flex;
		height: 100%;
		align-items: center;

		a.menu_item__parent__primary_link {
			position: relative;
			transition: color 0.2s ease;

			&:hover {
				color: var(--cpmec-blue);
				transition: color 0.2s ease;

				.has-children-indicator {
					svg {
						path {
							fill: var(--cpmec-blue);
							transition: color 0.2s ease;
						}
					}
				}
			}
		}

		&.last {
			div.inner_menu_child {
				ul.menu__child {
					display: flex;
					flex-direction: column;
					grid-column: 2 / span 1;
					left: unset;

					li {
						justify-content: flex-end;
					}
				}
			}
		}
	}

	div.inner_menu_child {
		position: absolute;
		left: 0;
		right: 0;
		z-index: 100;
		top: 100px;

		ul.menu__child {
			list-style: none;
			padding: 0;
			grid-column: 2 / span 1;
			min-width: 200px;
			background: white;
			min-height: auto;
			display: flex;
			flex-direction: column;
			grid-column: initial;
			position: absolute;
			left: calc(var(--distance-from-left));
			height: auto;
			top: -43px;
			padding: 28px 10px 10px;
			row-gap: 10px;

			&.has_overflow {
				li {
					justify-content: flex-end;
				}
			}

			li {
				&:hover {
					a {
						color: var(--cpmec-green);
					} 
				}
			}
		}
	}
}

.bounce-enter-active {
	animation: bounce-in 0.5s;
}

.bounce-leave-active {
	animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
	0% {
		transform: translateY(0px);
		opacity: 0;
	}
	50% {
		transform: translateY(30px);
		opacity: 1;
	}
	100% {
		transform: translateY(0px);
		opacity: 1;
	}
}

.bounce-reverse-enter-active {
	animation: bounce-in-rev 0.5s;
}

.bounce-reverse-leave-active {
	animation: bounce-in-rev 0.5s reverse;
}

@keyframes bounce-in-rev {
	0% {
		transform: translateY(0px);
		opacity: 0;
	}
	50% {
		transform: translateY(-10px);
		opacity: 1;
	}
	100% {
		transform: translateY(0px);
		opacity: 1;
	}
}

.fade-enter-active {
	animation: fade-in 0.5s;
}

.fade-leave-active {
	animation: fade-in 0.5s reverse;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

.slide-fade-enter-active {
	transition: all 0.25s ease;
}
.slide-fade-leave-active {
	transition: all 0.25s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(-20px);
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MenuItem.vue